import { Injectable } from '@angular/core';

import { StorageService } from '@base/services/storage.service';

@Injectable({
    providedIn: 'root',
})
export class PhonesStorageService extends StorageService {
    public KEY: { [index: string]: string } = {
        PRODUCTS: 'products',
        FILTERS: 'filters',
        PRICE_FILTER: 'price_filter',
        PRICES_BY_PLAN: 'prices_by_plan',
        PRICES_BY_PLAN_BOX: 'prices_by_box',
        PRICES_BY_RENEW_PLAN: 'prices_by_renew_plan',
        SORT: 'sort',
        USER_ACTION_MODAL: 'user_action_modal_clicked',
    };
    protected prefix: string = 'phones_wall_';

    protected sessionStorageKeys: string[] = Object.values(this.KEY);
}
